/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import React, { useState } from "react";
import axios from "axios"; // Import Axios

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import authorsTableData from "layouts/tables/data/authorsTableData";
import { Password } from "@mui/icons-material";
import { baseurl } from "domain";
import { useNavigate } from "react-router-dom";

import {
  TextField,
  Button,
  Container,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  Grid,
  Box,
} from "@mui/material";
// import Box from '@mui/material/Box';
import FormControl from "@mui/material/FormControl";
import AddUserEx from "components/module2";
// import Loading from "components/Loading";

function Tables() {
  const { columns, rows } = authorsTableData();
  // const [loading, setLoading] = useState(true); // Loading state
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    specialDayName: "", //text
    date: "", //calender
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formValues);

    const formData = new FormData();

    try {
      const response = await axios.post(`https://${baseurl}/addSpecialDay`, formValues);
      console.log("Question submitted successfully:", response.data);
      alert("Special Day added successfully!");
      navigate("/SpecialDays");
    } catch (error) {
      console.error("Error submitting question:", error);
    
      // Extract error message from response if available
      let errorMessage = "An error occurred. Please try again.";
      if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message; // Get error message from response
      }
    
      alert(errorMessage);
    } finally {
      // setLoading(false);
    }    
  };
  // if (loading) {
  //   return <Loading />; // Show loading component if data is still loading
  // }
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = () => {
    alert("Button clicked!");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                  <Grid item>
                    <MDTypography variant="h6" color="white">
                      Add Special Day
                    </MDTypography>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox pt={3}>
                <Container maxWidth="sm">
                  <Typography variant="h4" component="h1" gutterBottom>
                    Special Day Form
                  </Typography>
                  <br />
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Special Day Name"
                          name="specialDayName"
                          value={formValues.specialDayName}
                          onChange={handleChange}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Date"
                          name="date"
                          type="date" // This ensures the input works as a date picker
                          value={formValues.date}
                          onChange={handleChange}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true, // Keeps the label visible when a date is selected
                          }}
                        />
                      </Grid>

                      <Grid item xl={12} sl={"auto"} paddingBottom={4}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          height="100%"
                        >
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            style={{ color: "white" }}
                          >
                            Add Special Day
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </form>
                </Container>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12}></Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
